import React, { createContext, useContext, useEffect, useState } from 'react';
import { getItemApi } from '../apiUtils';
import { API_URL } from '../utils/apiUrl';

const ModuleContext = createContext<ModuleContextType>({
  isSparePartEnabled: null,
  isNfcEnabled: null,
  isMaintenanceCostEnabled: null,
});

function ModuleProvider(props: any) {
  const [isSparePartEnabled, setIsSparePartEnabled] = useState<boolean>();
  const [isNfcEnabled, setIsNfcEnabled] = useState<boolean>();
  const [isMaintenanceCostEnabled, setIsMaintenanceCostEnabled] = useState<boolean>();

  useEffect(() => {
    (async function () {
      await getItemApi<boolean>({
        url: `${API_URL.IS_MODULE_SPARE_PART_ENABLED}`,
        params: {},
        callAfterSuccess: (res) => {
          setIsSparePartEnabled(res);
        },
      });
      await getItemApi<boolean>({
        url: `${API_URL.IS_MODULE_NFC_ENABLED}`,
        params: {},
        callAfterSuccess: (res) => {
          setIsNfcEnabled(res);
        },
      });
      await getItemApi<boolean>({
        url: `${API_URL.IS_MODULE_MAINTENANCE_COST_ENABLED}`,
        params: {},
        callAfterSuccess: (res) => {
          setIsMaintenanceCostEnabled(res);
        },
      });
    })();
  }, []);

  return (
    <ModuleContext.Provider
      value={{ isSparePartEnabled, isNfcEnabled, isMaintenanceCostEnabled }}
      {...props}
    />
  );
}

interface ModuleContextType {
  isSparePartEnabled: boolean | null;
  isNfcEnabled: boolean | null;
  isMaintenanceCostEnabled: boolean | null;
}

const useModuleEnabled = () => useContext<ModuleContextType>(ModuleContext);

export { ModuleProvider, useModuleEnabled };
